<div class="view-toggle-container">
  <span
    [ngClass]="{ selected: show2d() }"
    class="view-selection"
    (click)="handleViewClick('2D')"
  >
    2D
  </span>
  |
  <span
    [ngClass]="{ selected: show3d() }"
    class="view-selection"
    (click)="handleViewClick('3D')"
  >
    3D
  </span>
</div>
